import React, { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

const AdminAuthmiddleware = (props) => {
  const navigate = useNavigate();
  useEffect(() => {
    const accessToken = localStorage.getItem("token");
    if (!accessToken) {
      navigate(`/auth/login`);
      return;
    }
    try {
      const decoded = jwtDecode(accessToken);
      if(decoded?.roleId !== "admin") {
        navigate(`/user/dashboard`);
      }
      const currentTime = Date.now() / 1000; // in seconds

      if (decoded.exp && decoded.exp < currentTime) {
        // Token expired
        localStorage.removeItem("token"); // clear token
        localStorage.removeItem("userInfo");
        navigate(`/auth/login`);
      }
    } catch (error) {
      console.error("Invalid token", error);
      localStorage.removeItem("token"); // bad token
      localStorage.removeItem("userInfo");
      navigate(`/auth/login`);
    }
  }, [navigate]);
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default AdminAuthmiddleware;
